import React from "react";
import ManageTeams from "../../../components/Profile/manageTeams";

const ManageTeam = () => {
  return (
    <>
      <ManageTeams />
    </>
  );
};

export default ManageTeam;
